import styled from "styled-components";

export const StyledClock = styled.div`
  font-family: "Roboto Mono", monospace;
  font-size: 12px;
  text-align: right;
  margin: 10px 5px 20px 0;
`;
